export const environment = {
  EnvironmentPlaceName: 'staging',
  production: false,
  clientId: '7929daf4-550d-47f6-929b-b4b872a6e1a3',
  authority: 'https://login.microsoftonline.com/f25493ae-1c98-41d7-8a33-0be75f5fe603',
  redirectUri: 'https://qa.validamais.volvotrucks.com.br',
  postLogoutRedirectUri: 'https://login.microsoftonline.com/common/oauth2/v2.0/logout',
  OcpToken: '',
  GRAPH_ENDPOINT: 'https://graph.microsoft.com/v1.0/me',
  msalConfig: {
    auth: {
      clientId: '7929daf4-550d-47f6-929b-b4b872a6e1a3',
      authority: 'https://login.microsoftonline.com/f25493ae-1c98-41d7-8a33-0be75f5fe603',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  appInsights: {
    instrumentationKey: '6412750c-e665-44e5-af1a-e312f28230ec',
    applicationName: 'app-validaplus-fe-qa',
  },

  //API Paths
  UrlApiValidPlus: 'https://app-validaplus-be-qa.azurewebsites.net/v1/',
};
